import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons'
import './QuoteSection.css'

function QuoteSection({ quoteText, quoteAuthor }) {
  return (
    <div className="quote-section">
      <div className="quote-icon">
        <FontAwesomeIcon icon={faQuoteLeft} />
      </div>
      <blockquote className="quote-text">
        {quoteText}
        <div className="quote-icon small-icon">
          <FontAwesomeIcon icon={faQuoteRight} />
        </div>
        <div className="quote-author">— {quoteAuthor}</div>
      </blockquote>
    </div>
  )
}

export default QuoteSection
